import template from './legal.html';
import { LegalController } from './legal.controller';

export const legalComponent = {
  name: 'legalComponent',
  restrict: 'E',
  template,
  controller: LegalController,
  controllerAs: 'vm',
  bindings: {},
};



// WEBPACK FOOTER //
// ./src/app/components/legal/legal.component.js